export const FEATURES_BASE_PATH = 'features';
